export default __webpack_public_path__ + "static/media/Featured Projects.7d68ed22.png";